/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-16 09:20:59
 */ 
export const InvoiceEn = {
    fapiaoxinxiguanl: "Invoice information list",
    qsrfpttsjh: "Please enter invoice title \ mobile phone number",
    addfp: "The new invoice",
    sprsj: "Mobile Phone:",
    sprdz: "Recipient address:",
    spryx: "e-mail address:",
    geren: "personage",
    gongsi: "corporation ",
    kaihuyh: "bank name:",
    yhzhuanghu: "bank account:",
    yingheng: "bank",
    ptfp: "plain invoice",
    zzsfp: "value added tax invoice",
    fptt: "invoice title:",
    ttmc: "Title:",
    nsrsbh: "Taxpayer ID",
    sprsf: "Province:",
    xxdz: "detailed address:",
    zcdh: "registration number:",
    zcdz: "regurl:",
    xiugaifpxx: "Modify invoice information",
    xinzengfpxx: "New invoice information",
    xuanzhefp: "select the invoice",
    qsrttmcnsrsbh: "Please enter your name/taxpayer identification number",
    morenfp: "The default invoice",
    danweimc: "company name:",
    shouprxm: "Name of consignee:",
    fapiaoleixin: "Invoice type",
    fapiaofenlei: "Classification of invoice",
}


// WEBPACK FOOTER //
// ./src/lang/member/Invoice/InvoiceEn.js